export const modifyBankAccount = (val) => {
  let firstFour = val.slice(0, 4);
  let lastTwo = val.slice(-2);
  let star = "*";

  return firstFour + star.repeat(val?.length - 6) + lastTwo;
};
